export type SupportedLanguage = 'de' | 'en';

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = ['de', 'en'];

const LANGUAGE_STORAGE_KEY = 'clavis_language';

function normalize(value: string | null | undefined): SupportedLanguage | null {
  if (!value) return null;
  const head = value.toLowerCase().split('-')[0];
  if (head === 'de' || head === 'en') return head;
  return null;
}

/**
 * Resolve the default language for the Welcome screen dropdown.
 *
 * Priority (spec 025 FR-004):
 *   1. URL `?lang=` parameter (caller passes urlLang)
 *   2. LocalStorage value (previous selection — i18next persists here)
 *   3. Browser navigator.language (first match, normalized to base lang)
 *   4. Fallback: 'en'
 *
 * Inputs are normalized via .split('-')[0] so 'de-CH' → 'de', 'en-US' → 'en'.
 * Unsupported languages (e.g. 'fr') fall through to the next layer.
 */
export function resolveDefaultLanguage(
  urlLang: string | null,
  options?: {
    storage?: Pick<Storage, 'getItem'>;
    navigatorLang?: string;
  },
): SupportedLanguage {
  const urlMatch = normalize(urlLang);
  if (urlMatch) return urlMatch;

  const storage = options?.storage ?? (typeof localStorage !== 'undefined' ? localStorage : undefined);
  const stored = normalize(storage?.getItem(LANGUAGE_STORAGE_KEY) ?? null);
  if (stored) return stored;

  const browser = normalize(
    options?.navigatorLang ?? (typeof navigator !== 'undefined' ? navigator.language : null),
  );
  if (browser) return browser;

  return 'en';
}
